<template>
  <div class="main-container">
    <HomePageHeader :active="active" :list="homepageImgList" />
    <SongList :now="now" :data="list" :active="active" @subscribe="handleSubscribe" :homepage-img-list="homepageImgList" :tab-img-list="tabImgList" />
    <CheckAuth />
  </div>
</template>
<script>
import HomePageHeader from "./HomePageHeader";
import SongList from "./SongList.vue";
import CheckAuth from "./CheckAuth.vue";
import { get } from "@changba/funny";

export default {
  name: "MainContainer",
  components: {
    HomePageHeader,
    SongList,
    CheckAuth,
  },
  data() {
    return {
      list: [],
      homepageImgList: [],
      tabImgList: [],
      now: "",
    };
  },
  computed: {
    active() {
      return this.$store.state.activeTabIndex;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { code, data, msg } = await get({
        url: `/api/activity/singWithYou/main`,
      });
      if (code === 1 && data && data.list.length) {
        this.list = data.list;
        this.homepageImgList = data.list.map((e) => e.img);
        this.tabImgList = data.list.map((e) => {
          return {
            tabActiveURL: e.tabActiveURL,
            tabInActiveURL: e.tabInActiveURL,
          };
        });
        this.now = data.current;
        // 拉取资源后默认设置分享第一个歌手
        this.$store.commit("setShareImg", this.homepageImgList[0]);
      } else {
        this.$toast(msg || "系统异常，请稍后重试！");
      }
    },
    handleSubscribe(activeIdx) {
      if (this.list[activeIdx]?.room) {
        this.list[activeIdx].room.isSubscribed = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  position: relative;
}
</style>
